
import { supabase } from '../client';
import { Product } from './types';

export const updateProduct = async (id: string, productData: Partial<Omit<Product, 'id' | 'created_at' | 'updated_at'>>): Promise<Product | null> => {
  try {
    console.log('[updateProduct] Updating product with ID:', id);
    console.log('[updateProduct] Data for update:', {
      name: productData.name,
      price: productData.price,
      mediaUrlsCount: productData.media_urls ? productData.media_urls.length : 0,
      mediaUrls: productData.media_urls,
      shopId: productData.shop_id,
      organizationId: productData.organization_id
    });
    
    // Handle empty SKU - set to null instead of empty string to avoid unique constraint issues
    if (productData.sku !== undefined && productData.sku === '') {
      productData.sku = null;
      console.log('[updateProduct] Empty SKU detected, setting to null to avoid unique constraint violation');
    }
    
    // Ensure media_urls is an array
    if (productData.media_urls !== undefined) {
      if (!Array.isArray(productData.media_urls)) {
        console.error('[updateProduct] media_urls must be an array, received:', productData.media_urls);
        productData.media_urls = [];
      } else {
        console.log('[updateProduct] media_urls before filtering:', productData.media_urls);
      }
      
      // Filter empty or invalid URLs
      const filteredUrls = productData.media_urls.filter(url => url && typeof url === 'string' && url.trim() !== '');
      productData.media_urls = filteredUrls;
      console.log('[updateProduct] Filtered media_urls before update:', filteredUrls);
    } else {
      console.log('[updateProduct] media_urls is undefined, not updating this field');
    }
    
    // Ensure benefits is valid JSONB if provided
    if (productData.benefits !== undefined) {
      if (!Array.isArray(productData.benefits)) {
        console.error('[updateProduct] benefits must be an array, received:', productData.benefits);
        productData.benefits = [];
      }
    }
    
    // Ensure faqs is valid JSONB if provided
    if (productData.faqs !== undefined) {
      if (!Array.isArray(productData.faqs)) {
        console.error('[updateProduct] faqs must be an array, received:', productData.faqs);
        productData.faqs = [];
      }
    }
    
    // Log if organization_id is being updated
    if (productData.organization_id !== undefined) {
      console.log('[updateProduct] Updating product organization_id to:', productData.organization_id);
    }
    
    // Log if form_id is being updated
    if (productData.form_id !== undefined) {
      console.log('[updateProduct] Updating product form_id to:', productData.form_id);
    }
    
    // Explicit update to ensure null values are handled correctly
    const { data, error } = await supabase
      .from('products')
      .update(productData)
      .eq('id', id)
      .select()
      .single();
    
    if (error) {
      console.error('[updateProduct] Error updating product:', error);
      throw error;
    }
    
    console.log('[updateProduct] Product updated successfully. Result:', {
      id: data.id,
      name: data.name,
      mediaUrlsCount: data.media_urls ? data.media_urls.length : 0,
      mediaUrls: data.media_urls
    });
    
    return data;
  } catch (error) {
    console.error(`[updateProduct] Failed to update product with ID ${id}:`, error);
    return null;
  }
};
